import { downloadFile } from '@/api/common'
import http from '@/plugin/axios'
import { Options } from '@/utils'

function downLoad(row: any) {
  downloadFile(process.env.VUE_APP_BASE_DATA_API + '/srmData/packDownload', { id: row.id }, row.dataName + '.zip')
}

async function release(this: any, row: any) {
  await http({
    url: '/srmData/release',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { id: row.id }
  })
  this.refresh()
}

async function start(this: any, row: any) {
  await http({
    url: '/srmData/startOrStop',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { id: row.id, status: '1' }
  })
  this.refresh()
}

async function stop(this: any, row: any) {
  await http({
    url: '/srmData/startOrStop',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { id: row.id, status: '2' }
  })
  this.refresh()
}

const status = new Options('data.data')
  .add('1', 'statusOptions[0]')
  .add('2', 'statusOptions[1]')

export {
  downLoad,
  release,
  start,
  stop,
  status
}
